export var BorderRadiusVariants = {
    "xxs": 0.25,
    "xs": 0.5,
    "sm": 0.75,
    "md": 1.0,
    "lg": 1.25,
    "xl": 1.5,
    "2xl": 2.0,
    "3xl": 2.5,
    "4xl": 3.0,
    "full": 999
};
